<template>
  <b-nav-item v-if="appConfig.educational_video">
    <b-button
      v-b-modal.educational-video-modal
      variant="gradient-warning"
      size="sm"
    >
      {{ $t('Educational video') }}
    </b-button>
  </b-nav-item>
</template>

<script>
import { BNavItem, BButton } from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'EducationalVideo',
  components: {
    BNavItem,
    BButton,
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
}
</script>

<style scoped>

</style>
